import * as AdminApi from './archibus/AdminApi'
import {fetchEmployee} from '../utils/employees'
import * as Data from './archibus-v2/DataApi'

export const fetchUserInfo = () => {
  let userInfo = {}
  return AdminApi.getUserInfo()
    .then(response => {
      userInfo = response

      return fetchEmployee({emId: userInfo.employee.id})
    })
    .then(employee => {
      userInfo.employee = {...userInfo.employee, ...employee}

      return Promise.resolve(userInfo)
    })
}

export const fetchUserDefaultLocation = ({
  blId = null,
  flId = null,
  rmId = null
}) => {
  let parameters = []

  if (blId) {
    parameters.push({name: 'bl_restriction', value: blId})
  }

  if (flId) {
    parameters.push({name: 'fl_restriction', value: flId})
  }

  if (rmId) {
    parameters.push({name: 'rm_restriction', value: rmId})
  }

  return Data.getDataFromDataSource(
    'ab-self-service.axvw',
    'locations',
    null,
    parameters
  ).then(({data}) => {
    let locations = data.reduce(
      (acc, curVal) => {
        const {tbl} = curVal
        acc[tbl] = curVal
        return acc
      },
      {bl: {}, fl: {}, rm: {}}
    )

    return Promise.resolve(locations)
  })
}
